module.exports = __webpack_public_path__ + "static/img/biogramy02ok.cfa37b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontpage/biogramy02ok.jpg
// module id = 9Cz9
// module chunks = 1